export default "__VITE_ASSET__BH$vGwLs__"